/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Matrix_ColourInputs */

const en_attribute_matrix_colour = /** @type {(inputs: Attribute_Matrix_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matrix colour`)
};

/**
* | output |
* | --- |
* | "Matrix colour" |
*
* @param {Attribute_Matrix_ColourInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_matrix_colour = /** @type {((inputs?: Attribute_Matrix_ColourInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Matrix_ColourInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_matrix_colour(inputs)
});